import { createSlice } from "@reduxjs/toolkit";

const userSlice = createSlice({
    name: "user",
    initialState: {
        user: null,
        userData: null,
        projects: null,
        searchProjectValue: null,
        activeProject: null,
        activeProjectUserRole: null,
        userGroupName: null,
        userGroupNamePlatform: null,
        platformAdminUsers: null,
        transfers: null,
        activeTransfer: null,
        isInsertDisabled: true,
        languages: null,
        activeLanguage: null,
        reviewResponseId: null,
        reviewFeatureResults: null,
        activeReviewFeatureResult: null,
    },
    reducers: {
        setUser: (state, action) => {
            state.user = action.payload.user;
        },
        setUserData: (state, action) => {
            state.userData = action.payload.userData;
        },
        setUserProjects: (state, action) => {
            state.projects = action.payload.projects;
        },
        setSearchProjectValue: (state, action) => {
            state.searchProjectValue = action.payload.searchProjectValue;
        },
        setActiveProject: (state, action) => {
            state.activeProject = action.payload.activeProject;
        },
        setActiveProjectUserRole: (state, action) => {
            state.activeProjectUserRole = action.payload.activeProjectUserRole;
        },
        setUserGroupName: (state, action) => {
            state.userGroupName = action.payload.userGroupName;
        },
        setUserGroupNamePlatform: (state, action) => {
            state.userGroupNamePlatform = action.payload.userGroupNamePlatform;
        },
        setPlatformAdminUsers: (state, action) => {
            state.platformAdminUsers = action.payload.platformAdminUsers;
        },
        setProjectTransfers: (state, action) => {
            state.transfers = action.payload.transfers;
        },
        setActiveTransfer: (state, action) => {
            state.activeTransfer = action.payload.transfer;
        },
        setIsInsertDisabled: (state, action) => {
            state.isInsertDisabled = action.payload.isInsertDisabled;
        },
        setProjectLanguages: (state, action) => {
            state.languages = action.payload.languages;
        },
        setActiveLanguage: (state, action) => {
            state.activeLanguage = action.payload.language;
        },
        setReviewFeatureResults: (state, action) => {
            state.reviewResponseId = action.payload.reviewResponseId;
            state.reviewFeatureResults = action.payload.reviewFeatureResults;
        },
        setActiveReviewFeatureResult: (state, action) => {
            state.activeReviewFeatureResult = action.payload.activeReviewFeatureResult;
        }
    }
})

export const {
    setUser,
    setUserData,
    setUserProjects,
    setSearchProjectValue,
    setActiveProject,
    setActiveProjectUserRole,
    setUserGroupName,
    setUserGroupNamePlatform,
    setPlatformAdminUsers,
    setProjectTransfers,
    setActiveTransfer,
    setIsInsertDisabled,
    setProjectLanguages,
    setActiveLanguage,
    setReviewFeatureResults,
    setActiveReviewFeatureResult
} = userSlice.actions;

export default userSlice.reducer;